import {
  PersonIcon,
  ExitIcon,
  CalendarIcon,
  PlaneIcon,
  HotelLine,
  TourIcon,
  CarLine,
} from '@assets/icons';
import { HotelRoomStatusType } from '@api/index';
import { APP_STATIC } from '@config/app-static';

export const BRAND_TEXT = 'Shop & Fly Kolay Seyahat Hattı';
export const BRAND_PHONE = '444 0 333';

export const NameValidation = {
  MAX_NAME_INPUT_LENGTH: 100,
  MAX_NAME_INPUT_LENGTH_ERROR_MESSAGE: 'Maksimum 100 karakter sınırı vardır.',
};

export const Currencies = {
  TL: 'TL',
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP',
};

export const LOYALTY_TYPES = {
  HOPI: 'HOPI',
  TURK_TELEKOM: 'TURK_TELEKOM',
};

export const TURKEY_COUNTRY_CODE = 'TR';

export const USER_MENU_ITEMS = [
  {
    icon: PersonIcon,
    name: 'Profilim',
    href: '/profil',
  },
  {
    name: 'Rezervasyonlarım',
    href: '/profil/rezervasyonlarim',
    icon: CalendarIcon,
  },
  {
    icon: ExitIcon,
    name: 'Çıkış Yap',
    href: '',
  },
];

export const SIDE_MENU_ITEMS = [
  {
    label: 'Profilim',
    link: '/profil',
    icon: 'profile',
  },
  {
    label: 'Rezervasyonlarım',
    link: '/profil/rezervasyonlarim',
    icon: 'calender',
  },
  {
    label: 'Çıkış Yap',
    link: '',
    icon: 'logout',
  },
];
export const KVKK_AGREEMENT =
  '<br/><br/>SİTE KULLANIM ŞARTLARI <br/>Lütfen sitemizi kullanmadan evvel bu ‘site kullanım şartları’nı dikkatlice okuyunuz.<br/>Bu alışveriş sitesini kullanan ve alışveriş yapan müşterilerimiz aşağıdaki şartları kabul etmiş varsayılmaktadır:<br/>Sitemizdeki web sayfaları ve ona bağlı tüm sayfalar (‘site’) https://www.setur.com.tr adresindeki Setur Servis Turistik A.Ş. firmasının (Firma) malıdır ve onun tarafından işletilir. Sizler (‘Kullanıcı’) sitede sunulan tüm hizmetleri kullanırken aşağıdaki şartlara tabi olduğunuzu, sitedeki hizmetten yararlanmakla ve kullanmaya devam etmekle; Bağlı<br/>olduğunuz yasalara göre sözleşme imzalama hakkına, yetkisine ve hukuki ehliyetine sahip ve 18 yaşın üzerinde olduğunuzu, bu sözleşmeyi okuduğunuzu, anladığınızı ve sözleşmede yazan şartlarla bağlı olduğunuzu kabul etmiş sayılırsınız.<br/>İşbu sözleşme taraflara sözleşme konusu site ile ilgili hak ve yükümlülükler yükler ve taraflar işbu sözleşmeyi kabul ettiklerinde bahsi geçen hak ve yükümlülükleri eksiksiz, doğru, zamanında, işbu sözleşmede talep edilen şartlar dâhilinde yerine getireceklerini beyan ederler.';

export const MEMBERSHIP_AGREEMENT =
  '<br/><br/>SİTE KULLANIM ŞARTLARI<br/>Lütfen sitemizi kullanmadan evvel bu ‘site kullanım şartları’nı dikkatlice okuyunuz.<br/>Bu alışveriş sitesini kullanan ve alışveriş yapan müşterilerimiz aşağıdaki şartları kabul etmiş varsayılmaktadır:<br/>Sitemizdeki web sayfaları ve ona bağlı tüm sayfalar (‘site’) https://www.setur.com.tr adresindeki Setur Servis Turistik A.Ş. firmasının (Firma) malıdır ve onun tarafından işletilir. Sizler (‘Kullanıcı’) sitede sunulan tüm hizmetleri kullanırken aşağıdaki şartlara tabi olduğunuzu, sitedeki hizmetten yararlanmakla ve kullanmaya devam etmekle; Bağlı<br/>olduğunuz yasalara göre sözleşme imzalama hakkına, yetkisine ve hukuki ehliyetine sahip ve 18 yaşın üzerinde olduğunuzu, bu sözleşmeyi okuduğunuzu, anladığınızı ve sözleşmede yazan şartlarla bağlı olduğunuzu kabul etmiş sayılırsınız.<br/>İşbu sözleşme taraflara sözleşme konusu site ile ilgili hak ve yükümlülükler yükler ve taraflar işbu sözleşmeyi kabul ettiklerinde bahsi geçen hak ve yükümlülükleri eksiksiz, doğru, zamanında, işbu sözleşmede talep edilen şartlar dâhilinde yerine getireceklerini beyan ederler.';

export const SF_MEMBERSHIP_AGREEMENT = `
**Setur Servis Turistik Anonim Şirketi**

**Platform Kullanım Koşulları**

**1. Giriş**

https://seyahat.shopandfly.com.tr internet sitesi (“Platform” olarak anılacaktır) üzerinden sağlanan seyahat hizmetleri Setur Servis Turistik Anonim Şirketi (“**Şirket**” veya “**Setur**”) tarafından sağlanmaktadır.

Platform’un ziyaretçiler ve/veya üyeler (birlikte “**Kullanıcı**”) tarafından kullanımı aşağıdaki hüküm ve şartlara tabidir. Lütfen Platform’u kullanmadan önce aşağıdaki Kullanım Koşulları’nı (“**Kullanım Koşulları**”) dikkatlice okuyunuz.

Platform’a erişerek ve/veya görüntüleyerek ve/veya kullanarak işbu Kullanım Koşulları’nı okuduğunuzu, anladığınızı ve bu koşullara uygun hareket edeceğinizi kabul etmektesiniz. İşbu Kullanım Koşulları ile bağlı olmak istememeniz halinde Platform’a erişmeme ve Platform’u kullanmama hakkınız saklı olup böyle bir kullanıma başlandı ise kullanımın derhal durdurulması gerekmektedir. Kullanıcı’nın Platform’u kullanmaya devam etmesi işbu Kullanım Koşulları’nı kabul ettiği anlamına gelmektedir.

Platform ile ilgili Türkiye Garanti Bankası A.Ş.’nin hakları saklıdır.

**2. Kullanım Koşulları**

Kullanıcı, Platform’da üyelik gerçekleştirmek istediği takdirde, üyelik için talep edilen bilgileri tam, doğru ve güncel bir şekilde sağlaması gerektiğini bildiğini kabul ve beyan eder. Kullanıcı, kullanıcı adı ve şifre de dahil olmak üzere tüm bilgilerin kullanım ve yönetiminden bizzat sorumludur. Kullanıcı’ya ait hesap, kullanıcı adı ve şifre ile gerçekleştirilen her işlem bizzat Kullanıcı tarafından gerçekleştirilmiş addedilecektir.

Başta Platform’da yayınlanan içerikleri olmak üzere, Platform’da yer alan hiçbir unsur Şirket’in izni olmaksızın başka internet sitelerinde ve/veya başka bir platformda yazılı, sözlü ve/veya elektronik olarak ve bunlarla sınırlı olmamak üzere herhangi bir şekilde yayımlanamaz, Şirket ile doğrudan ve/veya dolaylı olarak rekabet edecek şekilde kullanılmaz.

Şirket, Kullanıcı’ların bu kurallara aykırı olarak gerçekleştirdikleri faaliyetler nedeniyle üçüncü kişilerin uğradıkları veya uğrayabilecekleri zararlardan doğrudan ve/veya dolaylı olarak hiçbir şekilde sorumlu tutulamaz. Şirket’in üçüncü kişilerden bu kapsamda gelecek her türlü talep ile Kullanıcı’nın burada belirtilen yükümlülüklerini yerine getirmemesinden kaynaklanan zararları için ilgili Kullanıcı’ya rücu hakkı saklıdır.

Platform’un kullanımından kaynaklanan her türlü risk ile yasal, idari ve cezai sorumluluk Kullanıcı’ya aittir.

Kullanıcı, Platform’da gerçekleştireceği tüm işlemlerde işbu Kullanım Koşulları’nın hükümlerine, kanuna, ahlaka ve adaba, dürüstlük ilkelerine uyacağını kabul ve taahhüt eder. Ayrıca Kullanıcı, Platform dahilinde yer alan veri girişi yapabileceği hiçbir alanda üçüncü kişilerin haklarına tecavüz eden veya etme tehlikesi bulunan ifadelere yer vermeyeceğini, kişisel verilerin korunması mevzuatına aykırı şekilde veri sağlamayacağını, özellikle talep edilmedikçe gerek kendisine gerek üçüncü taraflara ait özel nitelikli kişisel veri girişinde bulunmayacağını, aksi takdirde tüm taleplerin kendisine rücu edileceğini kabul, beyan ve taahhüt eder.

Kullanıcı’nın bu Kullanım Koşulları’nı ihlal etmesi, yukarıda belirtilenlerle sınırlı olmamak üzere herhangi bir yöntem ile Platform’un işleyişini engelleyebilecek davranışlarda bulunması, Platform’a orantısız yük getirmesi, üçüncü kişilerin haklarına tecavüz eden veya etme tehlikesi bulunan fiillerde bulunması durumunda Şirket ilgili Kullanıcı’nın Platform’u kullanımını geçici veya daimî olarak durdurabilir. Kullanıcı’nın bu nedenle Şirket’ten herhangi bir talebi söz konusu olamaz. Kullanıcı, Platform’da yapılacak iyileştirme ve diğer değişikliklerin uygulanması için Platform’a erişimin geçici olarak engellenebileceğini kabul eder.

Şirket, Platform’da mevcut her tür hizmet, ürün, kullanma koşulları ile Platform’da sunulan bilgileri önceden bir ihtara gerek olmaksızın değiştirme, yeniden organize etme veya durdurma hakkını saklı tutar. Şirket herhangi bir bildirimde bulunmaksızın burada belirtilen koşullarda ve Platform’da yer alan diğer tüm metin ve bilgilerde dilediği zaman değişiklik yapabilir. Değişen hükümler yayınlandıkları tarihten itibaren geçerli olacaktır. Platform’un kullanımı ve görüntülenmesi ile bu değişiklikler de kabul edilmiş sayılır. Bu değişiklikleri takip edebilmeniz için düzenli aralıklarla işbu Kullanım Koşulları’nı incelemenizi önermekteyiz.

Şirket, Platform’da diğer platformların bağlantısını (link) verebilecek olup işbu linkler üzerinde Şirket’in herhangi bir kontrolü bulunmadığından Şirket linklerde yer alan içerik, reklam, ürün vb materyallerden sorumlu olmayacaktır. Kullanıcı’nın, işbu linkler sebebi ile uğrayacağı ve linkler vasıtasıyla elde edeceği herhangi bir içerik, reklam, ürün vb materyallere güvenerek hareket etmesi sebebi ile uğradığı herhangi bir zarar veya kayıptan doğrudan veya dolaylı olarak Şirket sorumlu olmayacaktır.

**3. Fikri Mülkiyet**

Şirket ve/veya Türkiye Garanti Bankası A.Ş.; Platform’un genel görünüm ve dizaynı ile Platform’da yer alan tüm bilgi, resim, Şirket ve/veya Türkiye Garanti Bankası A.Ş. markaları ve alan adı, logo, ikon, demonstratif, yazılı, elektronik, grafik veya makinede okunabilir şekilde sunulan teknik veriler, bilgisayar yazılımları, uygulanan satış sistemi, iş metodu ve iş modeli de dahil tüm materyallerin (“**Materyaller**”) ve bunlara ilişkin fikri ve sınai mülkiyet haklarının sahibi veya lisans sahibidir ve Materyaller yasal koruma altındadır. Platform’da bulunan hiçbir Materyal; önceden izin alınmadan ve kaynak gösterilmeden, kod ve yazılım da dahil olmak üzere, değiştirilemez, kopyalanamaz, çoğaltılamaz, dağıtalamaz, işlenemez, başka bir lisana çevrilemez, yeniden yayımlanamaz, başka bir bilgisayara yüklenemez, postalanamaz, iletilemez, sunulamaz ya da dağıtılamaz. Platform’un bütünü veya bir kısmı başka bir mecrada izinsiz olarak kullanılamaz. Aksine hareketler hukuki ve cezai sorumluluğu gerektirir. Şirket’in Kullanım Koşulları’nda açıkça belirtilen/belirtilmeyen diğer tüm hakları saklıdır.

**4. Sorumluluğun Sınırlandırılması**

Şirket, Platform’a girilmesi, Platform’un veya Platform’da yer alan bilgilerin ve diğer verilerin, programların vs. kullanılması sebebiyle doğabilecek doğrudan veya dolaylı hiçbir zarardan sorumlu değildir. Şirket, sözleşmenin ihlali, haksız fiil, ihmal veya diğer sebepler neticesinde; işlemin kesintiye uğraması, hata, ihmal, kesinti, silinme, kayıp, işlemin veya iletişimin gecikmesi, bilgisayar virüsü, telekomünikasyon hatlarında meydana gelen arızalar, iletişim hatası, hırsızlık, imha veya izinsiz olarak kayıtlara girilmesi, değiştirilmesi veya kullanılması hususunda herhangi bir sorumluluk kabul etmez. Kullanıcı; Platform’u kullanması, kullanmaması ya da yanlış kullanması veya Kullanım Koşulları’nda belirtilen taahhüt ve yükümlülüklerini yerine getirmemesi sebebiyle ortaya çıkacak doğrudan veya dolaylı zararlardan, her türlü kar kaybı, veri kaybı, iş kaybı, itibar kaybı, beklenen tasarrufun kaybı, işin kesintiye uğraması gibi her türlü maddi, manevi ve mali zararlardan, üçüncü bir tarafça yapılabilecek tazminat talepleri sonucu doğabilecek her tür sorumluluktan, mahkeme ve diğer masraflar da dahil olmak üzere her tür zarar ve talep hakkından Şirket’i beri kıldığını kabul ve taahhüt eder.

Platform ve ilgili içerikler “olduğu gibi” sunulmakta olup, Şirket’in Platform’un kapsamına ilişkin olarak zımni garanti, ticarete elverişlilik, belirli bir amaca uygunluk da dahil ancak bunlarla sınırlı olmamak üzere, açık veya zımni hiçbir türlü garantisi bulunmamaktadır.

Şirket dilediği zamanda Platform’u ve/veya işbu Kullanım Koşulları’nı süreli veya süresiz olarak askıya alabilecek, sona erdirebilecektir.

Son güncellenme tarihi: 26.08.2022
`;

export const SORT_DATA = [
  {
    id: 'popularity',
    label: 'Popüler',
    disabled: false,
  },
  {
    id: 'priceasc',
    label: 'Fiyata Göre (Artan)',
    disabled: false,
  },
  {
    id: 'pricedesc',
    label: 'Fiyata Göre (Azalan)',
    disabled: false,
  },
  {
    id: 'dateasc',
    label: 'Tarih (Yakın)',
    disabled: false,
  },
  {
    id: 'datedesc',
    label: 'Tarih (Uzak)',
    disabled: false,
  },
];

export const HOTEL_SORT_DATA = [
  {
    id: 'popularity',
    label: 'Popüler',
    disabled: false,
  },
  {
    id: 'priceasc',
    label: 'Fiyat (En Düşük)',
    disabled: false,
  },
  {
    id: 'pricedesc',
    label: 'Fiyat (En Yüksek)',
    disabled: false,
  },
  {
    id: 'rateasc',
    label: 'İndirim (En Düşük)',
    disabled: false,
  },
  {
    id: 'ratedesc',
    label: 'İndirim (En Yüksek)',
    disabled: false,
  },
  {
    id: 'PointDesc',
    label: 'Misafir Puanı',
    disabled: false,
  },
];

export const CAR_SORT_DATA = [
  {
    id: 'priceasc',
    label: 'Fiyata Göre (Artan)',
    disabled: false,
  },
  {
    id: 'pricedesc',
    label: 'Fiyata Göre (Azalan)',
    disabled: false,
  },
];

export const FUEL_TYPE = [
  {
    key: 1,
    value: 'Dizel',
    selected: false,
  },
  {
    key: 2,
    value: 'Benzin',
    selected: false,
  },
  {
    key: 3,
    value: 'Hibrit',
    selected: false,
  },
  {
    key: 4,
    value: 'Belirtilmemiş',
    selected: false,
  },
];

export const GEAR_TYPE = [
  {
    key: 1,
    value: 'Otomatik Vites',
    selected: false,
  },
  {
    key: 2,
    value: 'Düz Vites',
    selected: false,
  },
];

export const HOTEL_PAST_SEARCH = 'hotelPastSearch';
export const TOUR_PAST_SEARCH = 'tourPastSearch';
export const FLIGHT_PAST_SEARCH = 'flightPastSearch';
export const CRUISE_PAST_SEARCH = 'cruisePastSearch';
export const CAR_RENTAL_PAST_SEARCH = 'vehiclePastSearch';
export const TR_WEEK_DAY_NAMES = [
  'Pazar',
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi',
];

export const TURKEY_ID = '218';

export const BASKET_LOCKED_MESSAGE = 'Basket Kilitli.';

export enum ServiceTypes {
  HOTEL = 'HOTEL',
  TOUR = 'TOUR',
  FLIGHT = 'FLIGHT',
}
export const SKELETON_ITEMS_PLACEHOLDER = [1, 2, 3, 4, 5, 6, 7, 8];

export const advancePaymentStorageKey = 'advancePaymentStatus'; //local storage item name for Advance Payment Status
export const activePaymentMethodStorageKey = 'activePaymentMethod';

/**
 * cookie storage item name for payment page
 */
export const PAYMENT_CHANNEL = 'paymentChannel';
export const PAYMENT_REQUEST_ID = 'paymentRequestId';

/**
 * Security flags for the payment cookies above. These are written through the
 * `cookies-next` package, which applies no flags of its own, so they have to be
 * passed at every call site. Removal goes through the same options so the
 * expiring write carries identical attributes to the original.
 */
export const PAYMENT_COOKIE_OPTIONS = {
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'lax',
} as const;

export const AdvancePaymentStatus = {
  ON_GOING: 'ON_GOING',
  SUCCESS: 'SUCCESS',
  PAY_REMAINING_NOW: 'PAY_REMAINING_NOW',
};

export const INVISIBLE_CHATBOT_PAGES = [
  '/seyahat-planlama',
  '/rezervasyon-bilgileri',
  'Hotel',
  'Tour',
  '/ic-hat-ucuslari',
];

export const EXTRA_SERVICE_TYPES = {
  CANCELLATION_GUARANTEE: 11,
  ACTIVITY: 5,
  BUSINESS_CLASS_AIRPLANE: 2,
  GOLF_ACTIVITY: 8,
};

export const FILTERS_QUERY_PARAMS = [
  'priceMin',
  'priceMax',
  'refundable',
  'keywords',
  'status',
  'region',
  'theme',
  'category',
  'boardType',
  'date',
  'departure',
  'transportation',
  'visa',
  'specialPeriod',
  'feature',
  'popularity',
  'accommodationTaxType',
  'pricerange',
  'fueltypes',
  'transmissiontypes',
  'vehicleclasses',
  'doorcounts',
  'seatcounts',
  'luggagecounts',
  'point',
  'providers',
  'star',
  'category',
  'departure',
  'transportation',
  'visa',
  'specialPeriod',
  'page',
];

export const DATES_STATUS_TYPES = [
  {
    type: HotelRoomStatusType.OPEN_SALE,
    label: 'Müsait',
  },
  {
    type: HotelRoomStatusType.ASK_SELL,
    label: 'Sor Sat',
  },

  {
    type: HotelRoomStatusType.CLOSE_SALE,
    label: 'Kontenjan yok',
  },
];

export const HOST_URL =
  typeof window === 'undefined'
    ? process.env.NEXT_PUBLIC_HOST
    : window.location.origin;

export const DUMMY_BASKET_ID = '00000000-0000-0000-0000-000000000000';

/**
 * default collapse query param key for FAQ page
 * for example: /yardim/populer-sorular?defaultCollapse=1&defaultCollapse=2
 */
export const FAQ_DEFAULT_ACTIVE_QUERY_PARAM_KEY = 'defaultCollapse';

export const getCarRentalCommonReservationInfoText = (faqLink = '') =>
  `Online ön ödemeli olarak araç kiralıyorsunuz. [**Genel kiralama koşullarının**](${faqLink}) yerine getirilmemesi durumunda araç tahsis edilmeyecek olup yapılan ön ödeme tutarı iade edilmeyecektir. İade koşulları ve Genel Kiralama koşulları için [**Kullanım Şartları**](${faqLink})’nı okuyunuz.`;

export const getCarRentalFaqLink = (link = '', defaultCollapse?: number) => {
  if (defaultCollapse) {
    return `${link}?${FAQ_DEFAULT_ACTIVE_QUERY_PARAM_KEY}=${defaultCollapse}`;
  }
  return link;
};

export const VEHICLE_ONE_WAY_FEE_INFO_TEXT =
  'Alış ve teslim ofis farkının ücreti(drop ücreti) araç teslimi sırasında ofislerden tahsil edilecektir';

export const HOMEPAGE_TAB_MENU_LIST = [
  {
    id: 1,
    key: 'flight',
    text: 'Uçak',
    icon: PlaneIcon,
    iconRotate: false,
  },
  {
    id: 2,
    key: 'hotel',
    text: 'Otel',
    icon: HotelLine,
    iconRotate: false,
  },
  {
    id: 3,
    key: 'tour',
    text: 'Tur',
    icon: TourIcon,
    iconRotate: false,
  },
  {
    id: 5,
    key: 'carRental',
    text: 'Araç',
    icon: CarLine,
    iconRotate: false,
  },
  // {
  //   id: 4,
  // key: 'cruise',
  //   text: 'Gemi',
  //   icon: <CruiseIcon />,
  //   iconRotate: false,
  // },
];

export const HOTEL_DETAIL_TAB_MENU_LIST = [
  {
    id: 1,
    key: 'overview',
    text: 'Genel Bakış',
  },
  {
    id: 2,
    key: 'features',
    text: 'Otel Özellikleri',
  },
  {
    id: 3,
    key: 'rooms',
    text: 'Odalar',
  },
  {
    id: 4,
    key: 'location',
    text: 'Konum',
  },
  {
    id: 5,
    key: 'comments',
    text: 'Konuk Yorumları',
  },
  {
    id: 6,
    key: 'informations',
    text: 'Önemli Bilgiler',
  },
];

export const TOUR_DETAIL_TAB_MENU_LIST = [
  {
    id: 1,
    key: 'overview',
    text: 'Genel Bakış',
  },
  {
    id: 2,
    key: 'dates',
    text: 'Tur Tarihleri',
  },
  {
    id: 3,
    key: 'schedule',
    text: 'Tur Programı',
  },
  {
    id: 4,
    key: 'information',
    text: 'Hakkında',
  },
  {
    id: 5,
    key: 'services',
    text: 'Hizmetler',
  },
  {
    id: 6,
    key: 'conditions',
    text: 'Genel Şartlar',
  },
];

export const DYNAMIC_HOTEL_IMAGE_SIZE_LABEL = '{size}';

export const FALLBACK_IMAGE_URL = '/static/images/setur-static.webp';

export const CSO_STATE_KEY = 'cso-state';
export const CSO_CODE_CHALLENGE_KEY = 'cso-code-challenge';

/**
 * The default value of the number of days to revalidate the page.
 * 3600 seconds = 1 hour
 */
export const DEFAULT_REVALIDATE_TIME = 3600;

export const DEFAULT_IMAGE = '/static/images/placeholder-image.webp';

export const DEFAULT_ANCHOR_LINK = '#';

export const NOT_FOUND_META_INFO = {
  title: `Sayfa Bulunamadı - ${APP_STATIC.brand_name}`,
  description: 'Aradığınız sayfa bulunamadı.',
};
export const KKTC_WARNING_LINK =
  'https://nvi.gov.tr/bolu/kuzey-kibris-turk-cumhuriyetine-gidecek-vatandaslarimiza-duyurulur';

export const DEFAULT_API_ERROR_MESSAGE =
  'Şu anda işleminize devam edemiyoruz. Lütfen daha sonra tekrar deneyiniz.';
